export type PromoCampaignPublic = {
  code: string;
  name: string;
  amountOff: number;
  priceBefore: number;
  priceAfter: number;
  endLabel: string;
  startsAt: string;
  endsAt: string;
};

export type OutputType = { campaign: PromoCampaignPublic | null };

export const getPromoCampaign = async (init?: RequestInit): Promise<OutputType> => {
  const result = await fetch(`/_api/public/promo-campaign`, {
    method: "GET",
    ...init,
    headers: { "Content-Type": "application/json", ...(init?.headers ?? {}) },
  });
  const text = await result.text();
  if (!result.ok) throw new Error((JSON.parse(text) as { error: string }).error);
  return JSON.parse(text) as OutputType;
};
